import React from 'react';
import { CommonHistoryDropdown } from './CommonHistoryDropdown';
import { MachineryUseService } from '../../../services/MachineryUses';

/**
 * 機材予定履歴取得ドロップダウン
 * @param fieldTreeId {int} 協力会社ID
 * @param column {string} カラム名
 * @param set {function} 選択した値
 */
export class MachineryUseLatestRegistrationDropdown extends React.Component {
  /**
   * 履歴取得
   */
  getHistories = async fieldId => {
    if (!this.props.fieldTreeId) {
      return null;
    }

    const params = {
      field_id: fieldId,
      field_tree_id: this.props.fieldTreeId,
      work_hour_zone: sessionStorage.getItem('work_hour_zone'),
      column: this.props.column,
    };

    return await MachineryUseService.registrationHistoryList(
      fieldId,
      params
    ).then(response => {
      if (response.result) {
        return response.data.entities.machinery_uses;
      } else {
        return null;
      }
    });
  };

  render() {
    return (
      <CommonHistoryDropdown
        maxLength={255}
        {...this.props}
        getHistories={this.getHistories}
        resetKeys={[this.props.fieldTreeId]}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/MachineryUseLatestRegistration.jsx